//Library Imports
import { useDispatch, useSelector } from "react-redux";
//Local Imports
import Edit from "assets/img/icons/EditWorkflow.svg"
import Delete from "assets/img/icons/DeleteWorkflow.svg"
import CopyWorkFlow from "assets/img/icons/CopyWorkFlow.svg";
// actions Imports
import { addActionModal, copyNode, deleteActionModal, deleteConditionModal } from "../actions";
import { WFStatus, WFStatusEnum } from "../interfaces";
import { RootState } from "store";
import styled from "styled-components";

type PopoverContentProps = {
  id: string;
  isCondition?: boolean;
  controlName?: string;
  canCopy?: boolean;
  canEdit?: boolean;
  canDelete?: boolean;
  from?: string;
}

export default function PopoverContent(props: PopoverContentProps) {
  // Props
  const { id, isCondition, controlName, canCopy, canEdit, canDelete, from } = props;

  // Redux state
  const workflowStatus: WFStatus = useSelector((state: RootState) => state.automation.workflow?.detail?.status);
  const newlyAddedNodes: string[] = useSelector((state: RootState) => state.automation.workflow?.detail?.newlyAddedNodes);

  // Local variables
  const dispatch = useDispatch();
  const isStatusInactive = workflowStatus && workflowStatus === WFStatusEnum.INACTIVE;

  return (
    <Wrapper>
      <ul>
        {
          canEdit && (<li onClick={() => {
            dispatch(addActionModal(true, id, controlName, from));
          }}>
            <img src={Edit} alt="edit node" />
          </li>)
        }
        {
          canDelete && (<li className={`${isStatusInactive && !newlyAddedNodes?.includes(id) ? "disable" : ""}`} onClick={() => {
            if (isCondition) {
              dispatch(deleteConditionModal(true, id));
            } else {
              dispatch(deleteActionModal(true, id));
            }
          }}>
            <img src={Delete} alt="delete node" />
          </li>)
        }
        {
          canCopy && (<li onClick={() => dispatch(copyNode(id))}>
            <img src={CopyWorkFlow} alt="copy node" />
          </li>)
        }
      </ul>
    </Wrapper>
  )
}

PopoverContent.defaultProps = {
  isCondition: false,
  canCopy: true,
  canEdit: true,
  canDelete: true,
}

const Wrapper = styled.div`
  .disable{
    opacity: 0.3;
    pointer-events: none;
  }
`;